import { createActions, createReducer } from "reduxsauce";
export const { Types, Creators } = createActions({
    editarFrete: ["payload"],
    updateFilter: ["payload"],
    updateRelatorios: ["payload"],
    updateOcorrencias: ["payload"],
    updateRequest: ["payload"],
    updateTotal: ["payload"],
    setModal: ["payload"],
});
const INITIAL_STATE = {
    loadFrete: false,
    acordo: {},
    filters: {
        loading: false,
        search: "abertura",
        grouping: "entregador",
        order: -1,
    },
    requests: {
        loadingTotal: false,
        loading: false,
        filters: null,
        grouping: "entregador",
        search: null,
        order: -1,
    },
    relatorios: {
        concluidos: [],
        pendentes: [],
    },
    ocorrencias: {
        concluidos: [],
        pendentes: [],
    },
    modal: null,
    totais: [],
};

const editarFrete = (state = INITIAL_STATE, action) => ({
    ...state,
    acordo: action.payload,
});

const updateFilter = (state = INITIAL_STATE, action) => ({
    ...state,
    filters: {
        ...state.filters,
        ...action.payload,
    },
});

const updateRequest = (state = INITIAL_STATE, action) => ({
    ...state,
    requests: {
        ...state.requests,
        ...action.payload,
    },
});

const setModal = (state = INITIAL_STATE, action) => ({
    ...state,
    modal: action.payload,
    request: false,
});

const updateRelatorios = (state = INITIAL_STATE, action) => {
    const { tipo, data } = action.payload;
    let relatorios =
        tipo === "concluido"
            ? { pendentes: state.relatorios.pendentes, concluidos: data }
            : { pendentes: data, concluidos: state.relatorios.concluidos };

    return {
        ...state,
        relatorios: relatorios,
    };
};

const updateOcorrencias = (state = INITIAL_STATE, action) => {
    const { pendentes, concluidos } = action.payload;

    return {
        ...state,
        ocorrencias: { pendentes, concluidos },
    };
};

const updateTotal = (state = INITIAL_STATE, action) => ({
    ...state,
    totais: action.payload,
});
export default createReducer(INITIAL_STATE, {
    [Types.EDITAR_FRETE]: editarFrete,
    [Types.UPDATE_FILTER]: updateFilter,
    [Types.UPDATE_RELATORIOS]: updateRelatorios,
    [Types.UPDATE_OCORRENCIAS]: updateOcorrencias,
    [Types.UPDATE_REQUEST]: updateRequest,
    [Types.UPDATE_TOTAL]: updateTotal,
    [Types.SET_MODAL]: setModal,
});
